import React, { useEffect, useState } from "react";
import { AutoComplete } from "primereact/autocomplete";
import 'primeicons/primeicons.css';
import { Layers } from 'react-feather';
import ReactDOM from "react-dom";
import './../../quoter/styleQuoters/styleSeacrhQuoter.css'
import { useSearchQuoter } from "../../../hooks/quoter/useSearchQuoter";

export const IndexSearchQuoter = ({ handleSelectExamChange, id_company, setSelectedCompany, selectedCompany, chekTypeClient, handleSelectValues, listQuoterTest = [], clearQuotationTests, resetQuotationForAgreement  }) => {

  const {
    value,
    setValue,
    resultsSearch,
    setResultsSearch,
    searchGlobal,
    counts,
    loading,
    selectedAgreement,
    setSelectedAgreement,
    pendingSelection,
    setPendingSelection,
    showConfirm,
    setShowConfirm,
    parseAgreement,
    parseExamProfile,
    autoCompleteRef,
    syncOverlayPanel,
    overlayPanel,
    setOverlayPanel,
    resetSearch,
    disabled = false,

  } = useSearchQuoter(chekTypeClient);
  console.log("🐙 chekTypeClient", chekTypeClient);

  const sidebarOpen =
    localStorage.getItem("sidebartoggle") === "true";

  document.body.classList.toggle(
    "sidebar-open",
    sidebarOpen
  );
  const [showCreateMenu, setShowCreateMenu] = useState(false);
  const [highlightedItem, setHighlightedItem] = useState(null);
  const [showFilterMenu, setShowFilterMenu] = useState(false);

  const isMobile =
    window.matchMedia(
      "(hover: none) and (pointer: coarse)"
    ).matches;

  const hasAgreementSelected = !!selectedAgreement;


  const hadExams = resultsSearch.some(item =>
    item.type === "exam" || item.type === "profile"
  );
  //#region FILTER SEARCH
  const [selectedFilter, setSelectedFilter] = useState(
    chekTypeClient === 1
      ? "estudios"
      : "all"
  );

  useEffect(() => {

    if (chekTypeClient === 1) {
      setSelectedFilter("estudios");
    } else {
      setSelectedFilter("all");
    }

  }, [chekTypeClient]);
  const changeFilter = (filter) => {

    if (selectedFilter === filter) return;

    const hasText =
      typeof value === "string" &&
      value.trim().length > 0;

    setSelectedFilter(filter);

    if (!hasText) return;

    requestAnimationFrame(() => {

      const input =
        autoCompleteRef.current?.inputEL ||
        document.querySelector(
          ".custom-autocomplete-new-quoter input"
        );

      if (input) {
        input.focus();
      }

      if (
        autoCompleteRef.current &&
        autoCompleteRef.current.show
      ) {
        autoCompleteRef.current.show();
      }

    });
  };

  //#endregion
  const filteredResults = (() => {

    let base = [...resultsSearch];

    if (selectedFilter === "agreements") {

      base = base.filter(item =>
        item.isMessage ||
        (item.isGroup && item.group_name === "Convenios") ||
        item.type === "agreement"
      );

    }

    if (selectedFilter === "estudios") {

      base = base.filter(item =>
        item.isMessage ||
        (item.isGroup && item.group_name === "Estudios") ||
        item.type === "exam" ||
        item.type === "profile"
      );

    }

    if (chekTypeClient === 1) {

      base = base.filter(item =>
        item.type === "exam" ||
        item.type === "profile" ||
        item.isGroup ||
        item.isMessage
      );
    }

    if (
      chekTypeClient !== 1 &&
      !hasAgreementSelected
    ) {

      base = base.filter(item =>
        item.isMessage ||
        (item.isGroup && item.group_name === "Convenios") ||
        item.type === "agreement"
      );

      base.unshift({
        isMessage: true,
        isWarning: true,
        message: "Selecciona una empresa para ver los estudios"
      });

    }

    if (
      typeof value === "string" &&
      value.trim().length > 0 &&
      base.length === 0
    ) {

      let filterName = "resultados";

      if (selectedFilter === "agreements") {
        filterName = "empresas";
      }

      if (selectedFilter === "estudios") {
        filterName = "estudios";
      }

      base.push({
        isMessage: true,
        isEmptyFilter: true,
        message: `No se encontraron ${filterName}`
      });

    }

    return base;

  })();

  const renderItem = (item) => {

    if (item.type === "agreement") {

      const data = parseAgreement(item);

      return (
        <div className="item-quoter agreement card-agreement">

          <div className="item-quoter-icon agreement-icon">
            <i className="fa fa-building-o"></i>
          </div>

          <div className="agreement-content">
            <div className="agreement-header">

                <span className="agreement-code">
                    {data.code_company}
                </span>

                <span className="agreement-company-inline">
                    {data.company}
                </span>

            </div>

            <div className="agreement-contract">
              {data.contract_number}
            </div>

          </div>

        </div>

      );
    }
    if (item.isMessage) {
      return (
        <div
          className={`search-banner-quoter
            ${item.isAllReported ? "success" : ""}
            ${item.isWarning ? "warning" : ""}
            ${item.isEmptyFilter ? "empty-filter-quoter" : ""}
          `}
        >
          <i
            className={
              item.isAllReported
                ? "fa fa-check-circle"
                : item.isWarning
                  ? "pi pi-exclamation-triangle"
                  : item.isEmptyFilter
                    ? "pi pi-filter"
                    : "pi pi-search"
            }
          ></i>

          <span>{item.message}</span>
        </div>
      );
    }



    if (item.isGroup) {
      const getIcon = (name) => {
        if (name.includes("Convenios")) return "fa fa-building-o";
        if (name.includes("Estudios")) return "fa fa-flask";
        return "pi pi-th-large";
      };

      const getCount = () => {
        if (item.group_name === "Convenios") return counts.agreements;
        if (item.group_name === "Estudios") return counts.exams + counts.profiles;
        return 0;
      };

      return (
        <div className="group-header-quoter-ios">
          <div className="group-header-quoter-left">
            <div className={`group-icon-quoter-container ${item.group_name.toLowerCase()}`}>
              <i className={getIcon(item.group_name)}></i>
            </div>
            <span className="group-title-quoter">{item.group_name}</span>
          </div>
          <div className="group-header-quoter-right">
            <span className="result-badge-quoter">
              {getCount()} resultados
            </span>
          </div>
        </div>
      );
    }


    if (item.type === "exam" || item.type === "profile") {
      const data = parseExamProfile(item.component);

      return (
        <div className="item exam card-examAdmission">
          <div className="item-quoter-icon exam-quoter-icon">
            {data.type === "PERFIL" ? (
              <Layers size={16} />
            ) : (
              <i className="fa fa-flask"></i>
            )}
          </div>

          <div className="exam-quoter-content">
            <div className="exam-quoter-header">
              <div className="badge-abbreviation">
                {data.abbreviation}
              </div>

              <div className="exam-type">
                <span className={`quoter-type ${data.type.toLowerCase()}`}>
                  {data.type}
                </span>
              </div>
            </div>

            <div className="item-title-exam-profiles-quoter">
              {data.name}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="item-quoter exam">
        <div className="item-quoter-icon">
          <i className="pi pi-file"></i>
        </div>

        <div className="item-text-quoter">
          <div className="item-title-exam-profiles-quoter">{item.component}</div>
        </div>
      </div>
    );
  };


  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === "k") {
        e.preventDefault();

        const input = document.querySelector(".custom-autocomplete-new-quoter input");
        if (input) {
          input.focus();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const dynamicPlaceholder = (() => {

    if (chekTypeClient === 1) {
      return "Buscar estudios...";
    }

    if (!selectedAgreement) {
      return "Buscar empresa...";
    }

    return "Buscar estudios...";
  })();


  useEffect(() => {
    resetSearch();
    setValue("");

  }, [chekTypeClient]);

  const confirmChangeAgreement = () => {

      const selected = pendingSelection;

      if (!selected) return;

      resetQuotationForAgreement();

      setSelectedAgreement(selected);
      setSelectedCompany(selected);

      handleSelectValues(
          {
              value: selected.id_agreement,
              id_company: selected.id_company,
              is_list_limited: selected.is_list_limited
          },
          "id_agreement"
      );

      /*
      |--------------------------------------------------------------------------
      | LIMPIAR ESTUDIOS
      |--------------------------------------------------------------------------
      */

         clearQuotationTests();

      setValue("");
      setResultsSearch([]);

      setPendingSelection(null);
      setShowConfirm(false);
  };

  const footerContent = (
    <div className={showConfirm ? "footer-confirm-mode" : "footer-ios"}>
      
        <div
              className="confirm-card"
              onMouseDown={(e)=>{
                  e.preventDefault();
                  e.stopPropagation();
              }}
          >

          <div className="confirm-header">
            <div className="confirm-icon">!</div>

            <div className="confirm-texts">
              <div className="confirm-title">
                  ¿Cambiar empresa?
              </div>

              <div className="confirm-sub">
                  Se eliminarán todos los estudios agregados y se cargará el nuevo convenio {" "} <strong>
                    {pendingSelection?.code_company} - {pendingSelection?.name_company}
                </strong>
              </div>

              
            </div>
          </div>
        
          <div className="confirm-actions">
           <button
                className="btn-confirm"
                onClick={confirmChangeAgreement}
            >
              CONFIRMAR CAMBIO
            </button>

            <button
              className="btn-cancel"
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onClick={() => {
                setShowConfirm(false);

                setTimeout(() => {
                  autoCompleteRef.current.show();
                }, 0);
              }}
            >
              CANCELAR
            </button>
          </div>

        </div>
      
    </div>
  );

  const filterOptions =
    chekTypeClient === 1
      ? [
        {
          key: "estudios",
          icon: "fa fa-flask",
          className: "studies",
          label: "Estudios",
          title: "Filtrar estudios"
        }
      ]
      : [
        {
          key: "all",
          icon: "pi pi-search",
          className: "search",
          label: "Todos",
          title: "Traer todos los resultados"
        },
        {
          key: "agreements",
          icon: "fa fa-building-o",
          className: "agreements",
          label: "Empresas",
          title: "Filtrar empresas"
        },
        {
          key: "estudios",
          icon: "fa fa-flask",
          className: "studies",
          label: "Estudios",
          title: "Filtrar estudios"
        }
      ];

  return (
    <div
      className={`
            search-container-full-quoter
            admission-search
            ${chekTypeClient === 1
          ? "particular-mode"
          : "agreement-mode"
        }
        `}
    >
      <div className="search-filters-left-quoter">

        {isMobile ? (

          <div className="filter-menu-wrapper">

            <button
              type="button"

              className={`filter-quoter-pill ${filterOptions.find(
                x => x.key === selectedFilter
              )?.className || "search"
                } active`}
              onClick={() => {
                setShowCreateMenu(false);
                setShowFilterMenu(v => !v);
              }}

            >
              <i
                className={
                  filterOptions.find(
                    x => x.key === selectedFilter
                  )?.icon
                }
              />
            </button>

            {showFilterMenu && (
              <div className="floating-filter-menu">

                {filterOptions.map(filter => (
                  <button
                    key={filter.key}
                    disabled={disabled}
                    className={
                      selectedFilter === filter.key
                        ? "active"
                        : ""
                    }
                    onClick={() => {

                      changeFilter(filter.key);

                      setShowFilterMenu(false);

                    }}
                  >
                    <i className={filter.icon}></i>
                    <span>{filter.label}</span>
                  </button>

                ))}

              </div>
            )}

          </div>

        ) : (

          filterOptions.map(filter => (

            <button
              key={filter.key}
              type="button"
              className={`filter-quoter-pill ${filter.className}
                    ${selectedFilter === filter.key
                  ? "active"
                  : ""
                }`}

              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onClick={() =>
                changeFilter(filter.key)
              }
              title={filter.title}
            >
              <i className={filter.icon}></i>
            </button>
          ))
        )}

      </div>
      <div className="autocomplete-wrapper-quoter">

        <AutoComplete
          ref={autoCompleteRef}
          suggestions={
            loading
              ? [{ isMessage: true, message: "Buscando..." }]
              : filteredResults
          }
          disabled={disabled}
          panelClassName={`custom-panel-new-quoter ${showConfirm ? "blocked" : ""}`}
          className={`custom-autocomplete-new-quoter`}
          value={typeof value === "string" ? value : ""}
          completeMethod={searchGlobal}
          field={
            selectedAgreement
              ? "component"
              : "name_company"
          }
          placeholder={dynamicPlaceholder}
          onChange={(e) => setValue(e.value)}
          appendTo="self"
          onKeyDown={(e) => {

              if (e.key !== "Enter") return;

              if (!highlightedItem) return;

              e.preventDefault();

              if (
                      highlightedItem.type === "agreement" ||
                      highlightedItem.type === "exam" ||
                      highlightedItem.type === "profile"
                  ) {
              }

          }}

          onKeyUp={() => {

              const active = document.querySelector(
                  ".p-autocomplete-item.p-highlight"
              );

              if (!active) return;

              const index = [...document.querySelectorAll(".p-autocomplete-item")]
                  .indexOf(active);

              if (index >= 0) {
                  setHighlightedItem(filteredResults[index]);
              }

          }}
          itemTemplate={(item) => (

              <div
                  className={showConfirm ? "item-quoter-disabled" : ""}
                  style={{
                      pointerEvents: showConfirm ? "none" : "auto",
                      opacity: showConfirm ? .45 : 1
                  }}
              >
                  {renderItem(item)}
              </div>

          )}
          onShow={syncOverlayPanel}
          onHide={() => {
            if (showConfirm) return;
            setOverlayPanel(null);
          }}

          onBlur={() => {
            if (
              document.activeElement &&
              typeof document.activeElement.blur === "function"
            ) {
              document.activeElement.blur();
            }
          }}

          onSelect={(e) => {

            const selected = e.value;

            console.log("SELECTED", selected);

              if (selected?.type === "agreement") {

              const hasStudies =
                  Array.isArray(listQuoterTest) &&
                  listQuoterTest.length > 0;

              const isChangingAgreement =
                  selectedAgreement &&
                  selectedAgreement.id_agreement !== selected.id_agreement;

              if (
                  isChangingAgreement &&
                  hasStudies
              ) {
                  setValue("");  
                  setPendingSelection(selected);
                  setShowConfirm(true);

                  return;
              }
              

              setSelectedAgreement(selected);
              setSelectedCompany(selected);

              handleSelectValues(
                  {
                      value: selected.id_agreement,
                      id_company: selected.id_company,
                      is_list_limited: selected.is_list_limited
                  },
                  "id_agreement"
              );

              setValue("");
              setResultsSearch([]);

              return;
            }
            if (
              selected?.type === "exam" ||
              selected?.type === "profile"
            ) {

              const value = `${selected.id_component}-${selected.type === "exam" ? 0 : 1}`;

              console.log("VALUE ENVIADO", value);

              handleSelectExamChange({
                target: {
                  name: "id_profileExam",
                  value
                }
              });

              setValue("");
              setResultsSearch([]);
            }
          }}
        />
        <div className="shortcut-hint">
          <span>CTRL</span>
          <span>K</span>
        </div>
      </div>
      {showConfirm &&
          overlayPanel &&
          ReactDOM.createPortal(
              footerContent,
              overlayPanel
          )

      }

      {/* EJEMPLO DE SOLO MOVIL */}
      {/* <div className="mobile-only">
        búsqueda por voz
      </div> */}

    </div >
  );
};